export const CREATE_Certification = 'CREATE_Certification ';

export const createCertification = certification => ({
    type: CREATE_Certification,
    payload: {certification}
});

export const REMOVE_Certification = 'REMOVE_Certification ';

export const removeCertification = certification => ({
    type: REMOVE_Certification,
    payload: {certification}
});
